import { MegaphoneFill } from "react-bootstrap-icons";

// Renders the colleagues tagged on a note; accepts any shape exposing `name`.
// Caps the visible names and appends "+N more" beyond `max`.
export default function TaggedUsers({ users, max = 3 }) {
  if (!users?.length) return null;

  const visible = users.slice(0, max);
  const extra = users.length - visible.length;
  const names = visible.map((user) => `@${user.name}`).join(" ");

  return (
    <div className="mt-1 flex items-center gap-1.5 text-xs text-zinc-500">
      <MegaphoneFill aria-hidden="true" className="size-3.5 shrink-0 text-zinc-400" />
      <span className="truncate">
        {names}
        {extra > 0 && ` +${extra} more`}
      </span>
    </div>
  );
}
